module.exports = "<div class=\"blanco col-md-7\" ng-if=projectsVm.thereIsDetails()> <div ng-include=\"'details-header-project'\"></div> </div> <div class=\"col-md-7 m-t-lg p-t-lg\" layout=row layout-sm=column layout-align=space-around ng-if=projectsVm.isLoadingDetails> <md-progress-circular md-mode=indeterminate ng-disabled=\"projectsVm.thereIsDetails() || projectsVm.searchValue\" md-diameter=96> </md-progress-circular> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/research/projects/list/project-details.html
// module id = 680
// module chunks = 0